export * from '@erp/ui/smooth-waveform';
